import { Avatar, AvatarGroup, Chip, Tooltip } from '@mui/material';
import { type GridColDef, type GridRenderCellParams } from 'esseal-data-table';

import { type ProjectTemplate, type CompanyTag, type CompanyResource } from '@/graphql/generated/graphql';

const projectTemplatesColumns: GridColDef<ProjectTemplate>[] = [
  {
    field: 'title',
    headerName: 'Title',
    width: 180,
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 180,
    renderCell: ({ value }: GridRenderCellParams<ProjectTemplate>) => (value ? value : '-'),
  },
  {
    field: 'tags',
    headerName: 'Tags',
    width: 300,
    renderCell: ({ row }: GridRenderCellParams<ProjectTemplate>) =>
      row.tags?.map(({ id, title }: CompanyTag) => (
        <Chip key={`${id}-${title}-tag`} label={title} variant="outlined" sx={{ mr: 0.5 }} />
      )),
  },
  {
    field: 'managers',
    headerName: 'Managers',
    width: 300,
    sortable: false,
    renderCell: ({ row }: GridRenderCellParams<ProjectTemplate>) => (
      <AvatarGroup
        max={5}
        slotProps={{
          surplus: {
            sx: { cursor: 'pointer' },
            title: (row?.companyResources ?? [])
              .slice(5)
              .map((resource: CompanyResource) => `${resource.name}`)
              .join('\n'),
          },
        }}
      >
        {(row?.companyResources ?? []).map((resource: CompanyResource) => (
          <Tooltip key={resource.id} title={`${resource.name}`}>
            <Avatar alt={`${resource.name}`} src={''} sx={{ fontSize: 14 }}>
              {resource.name[0]}
            </Avatar>
          </Tooltip>
        ))}
      </AvatarGroup>
    ),
  },
];

export default projectTemplatesColumns;
